import CustomButton from "../../../components/CustomButton";
import userRoles from "../../../constants/userRoles";
import { crudRoutes, recallRoutes } from "../../../router/routesConstants";
import usePermissions from "../../../router/usePermissions";
import Text from "../../../styleguide/Text";

function RecallEntriesHeader() {
  const { isAuthorized } = usePermissions();

  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
      <Text
        variant="h3"
        component="h3"
        className="font-semibold text-slate-900">
        Centralizator retrageri
      </Text>
      {isAuthorized(userRoles.RECALL) && (
        <CustomButton
          icon="ADD"
          variant="contained"
          navigate={`/${recallRoutes.recall}/${crudRoutes.create}`}>
          Creeaza retragere
        </CustomButton>
      )}
    </div>
  );
}

export default RecallEntriesHeader;
